import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, securePUT, withQuery } from '../utilities/FetchHelper';

class HotelAmenititesService {

    getMasterHotelAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_MASTER_HOTEL_AMENITIES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }

        if (data.queryParams) {
            url = withQuery(url, data.queryParams)
        }

        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    getHotelAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_AMENITIES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, secureGET()).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }

    putHotelAmenities(data) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_AMENITIES
        for (const key in data) {
            url = url.replace('{' + key + '}', data[key])
        }
        return fetchJSON(url, { ...securePUT(), body: JSON.stringify(data) }).then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new HotelAmenititesService()